import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Properties from '@/views/Properties.vue'
import PropertyDetails from '@/views/PropertyDetails.vue'
import Services from '@/views/Services.vue'
import Projects from '@/views/Projects.vue'
import About from '@/views/About.vue'
import Blog from '@/views/Blog.vue'
import BlogDetails from '@/views/BlogDetails.vue'
import Contact from '@/views/Contact.vue'

const routes = [
  { path: '/', name: 'home', component: Home, meta: { title: 'Premium Real Estate in Nigeria', description: 'Discover property sales, rentals, development and professional real estate services across Lagos.' } },
  { path: '/properties', name: 'properties', component: Properties, meta: { title: 'Properties | Aurelia Properties' } },
  { path: '/properties/:slug', name: 'property-details', component: PropertyDetails, meta: { title: 'Property Details | Aurelia Properties' } },
  { path: '/services', name: 'services', component: Services, meta: { title: 'Real Estate Services | Aurelia Properties' } },
  { path: '/projects', name: 'projects', component: Projects, meta: { title: 'Projects | Aurelia Properties' } },
  { path: '/about', name: 'about', component: About, meta: { title: 'About Us | Aurelia Properties' } },
  { path: '/blog', name: 'blog', component: Blog, meta: { title: 'Property Insights | Aurelia Properties' } },
  { path: '/blog/:slug', name: 'blog-details', component: BlogDetails, meta: { title: 'Article | Aurelia Properties' } },
  { path: '/contact', name: 'contact', component: Contact, meta: { title: 'Contact | Aurelia Properties' } }
]

const router = createRouter({ history: createWebHistory(), routes, scrollBehavior: () => ({ top: 0, behavior: 'smooth' }) })
router.afterEach((to) => {
  document.title = to.meta.title || 'Aurelia Properties'
  const description = to.meta.description || 'Premium Nigerian real estate services.'
  let tag = document.querySelector('meta[name="description"]')
  if (!tag) { tag = document.createElement('meta'); tag.name = 'description'; document.head.appendChild(tag) }
  tag.setAttribute('content', description)
})
export default router
